
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ltd",
      function () {
        return require("private-next-pages/ltd.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ltd"])
      });
    }
  